import { render, staticRenderFns } from "./CardBodySingleChipReview.vue?vue&type=template&id=5ffcd1fd&scoped=true"
import script from "./CardBodySingleChipReview.vue?vue&type=script&lang=ts"
export * from "./CardBodySingleChipReview.vue?vue&type=script&lang=ts"
import style0 from "./CardBodySingleChipReview.vue?vue&type=style&index=0&id=5ffcd1fd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffcd1fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ffcd1fd')) {
      api.createRecord('5ffcd1fd', component.options)
    } else {
      api.reload('5ffcd1fd', component.options)
    }
    module.hot.accept("./CardBodySingleChipReview.vue?vue&type=template&id=5ffcd1fd&scoped=true", function () {
      api.rerender('5ffcd1fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardBodySingleChipReview.vue"
export default component.exports